import { Component, OnInit, ViewChild } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { IMerchant } from '@interfaces/merchant.interface';
import { MatDialog } from '@angular/material';
import * as adminReducer from '@modules/super-admin/reducers';
import { ConfirmDialogComponent } from '@modules/shared/components/confirm-dialog/confirm-dialog.component';
import { Subscription } from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {MerchantDetailService} from '@modules/super-admin/services/merchant-detail.service';
import _ from 'lodash';
import { MessengerService } from '@modules/messenger/messenger.service';
import * as loginReducers from '@modules/login/reducers';
import { ROLES } from '@root/resources/enums/role.enum';


@Component({
  selector: 'edex-sales-merchant',
  templateUrl: './sales-merchant.component.html',
  styleUrls: ['./sales-merchant.component.scss']
})
export class SalesMerchantComponent implements OnInit {
  displayedColumns: string[] = ['contactName', 'email', 'phoneNumberCall', 'companyName', 'status','transactions'];
  dataSource = new MatTableDataSource<IMerchant>([]);
  merchantStatusOptions = [
    { label: 'All', value: '' },
    { label: 'Web applications', value: 'web' },
    { label: 'Information upload stage', value: 'upload' },
    { label: 'Being assessed', value: 'assessed' },
    { label: 'Approved', value: 'approved' },
    { label: 'Website/POS integration Stage', value: 'integration' },
    { label: 'Live and Processing', value: 'processing' },
  ];

  merchantStatus = '';
  search = '';
  debouncedFilter;
  payProcess = ['Payrix', 'Paypal', 'Stripe'];

  private merchantsSub: Subscription;
  public merchants$ = this.store.pipe(select(adminReducer.getMerchants));
  public loginEmailRole$ = this.store.pipe(select(loginReducers.getUserRole));

  @ViewChild(MatPaginator) paginator: MatPaginator;
  showAsPrRole: boolean = false;

  constructor(
    private store: Store<adminReducer.State>,
    private router: Router,
    private msgr: MessengerService,
    private route: ActivatedRoute,
    private merchantApiService: MerchantDetailService,
    public dialog: MatDialog,
  ) {
    this.debouncedFilter = _.debounce(this.applyFilter.bind(this), 500);
  }

  GotoTransactions (merchant:any) {
      this.router.navigateByUrl(`/salesagent-transaction/${merchant._id}`)
  }

  ngOnInit() {
    this.route.queryParamMap.subscribe((query) => {
      this.merchantStatus = query.get('status') || '';
      this.search = query.get('search') || '';
      this.getSAmerchants();
    });
  }

  getSAmerchants() {
    this.merchantApiService.getSAmerchants({
      status: this.merchantStatus,
      search: this.search,
      isDeleted: false,
    }).subscribe(
      (merchants) => {
        console.log('merchants',merchants);
        
        this.dataSource = new MatTableDataSource<IMerchant>(merchants);
        this.dataSource.paginator = this.paginator;
      },
      (err) => {

      }
    );
  }

  deactivateMerchant(event: Event, merchant: IMerchant) {
    event.stopPropagation();

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        text: 'Are you sure to deactivate this merchant?'
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.merchantApiService.deactivateMerchant({
          id: merchant._id,
        }).subscribe(
          (data) => {
            this.getSAmerchants()
            this.msgr.message('User account deactivate')
          },
          (err) => {
            this.msgr.error('Something went wrong...');
          }
        );
      }
    });
  }


  applyFilter() {
    this.router.navigate(['/admin/users/merchants'], {
      queryParams: {
        status: this.merchantStatus,
        search: this.search,
      },
    }).then();
  }

  ngOnDestroy() {
    if (this.merchantsSub) {
      this.merchantsSub.unsubscribe();
    }
  }

  checkRole(){
    this.loginEmailRole$.subscribe(role => {
      if (role === ROLES.ADMIN || role === ROLES.SUPER_ADMIN) {
        this.showAsPrRole = false;
      } else if(role === ROLES.SALES_AGENT){
        this.showAsPrRole = true;
      }
    });
  }
}
